import * as React from "react"
import NumberFormat from "react-number-format"
import { debounce } from "lodash"

interface Props {
  value: string
  onValueChange: (value: string) => void
}

interface State {
  currentValue: string
}

export class RecipientCustomAmountInput extends React.Component<Props, State> {
  persistValueDebounced: () => any

  constructor(props: Props) {
    super(props)
    this.persistValueDebounced = debounce(this.persistValue, 500)
  }

  persistValue = (value) => {
    this.props.onValueChange(value.formattedValue)
  }

  render() {
    return (
      <NumberFormat
        className="w-20 sm:w-24 sm:mx-1"
        thousandSeparator={true}
        prefix={"$"}
        defaultValue={this.props.value}
        onValueChange={this.persistValueDebounced}
        data-role={"amount-input"}
        placeholder={"$"}
      />
    )
  }
}
